<template>
    <span v-if="!displayAsLabel"
          :class="`currency-wrapper ${(showLeftRight ? 'currency-wrapper--with-buttons' : '')}`">
        <div v-if="showLeftRight"
             class="currency-wrapper__buttons currency-wrapper__buttons--left">
            <hh-btn v-if="showLeftRightFaster"
                    :text="decrementFastIconClass ? '' : decrementFastText"
                    :icon-class="decrementFastIconClass"
                    class="currency-wrapper__buttons__button currency-wrapper__buttons__button--decrement-faster"
                    @keydown="onFastDecrementButtonKeyDown"
                    @keyup="onFastDecrementButtonKeyUp"
                    @mousedown="onFastDecrementButtonDown"
                    @mouseup="onFastDecrementButtonUp"
                    @touchstart="onFastDecrementButtonDown"
                    @touchend="onFastDecrementButtonUp"
                    @touchcancel="onFastDecrementButtonUp" />
            <hh-btn :text="decrementIconClass ? '' : decrementText"
                    :icon-class="decrementIconClass"
                    class="currency-wrapper__buttons__button currency-wrapper__buttons__button--decrement"
                    @keydown="onDecrementButtonKeyDown"
                    @keyup="onDecrementButtonKeyUp"
                    @mousedown="onDecrementButtonDown"
                    @mouseup="onDecrementButtonUp"
                    @touchstart="onDecrementButtonDown"
                    @touchend="onDecrementButtonUp"
                    @touchcancel="onDecrementButtonUp" />
        </div>
        <hh-tooltip text="Click to edit directly"
                    position="top"
                    top-bottom-position-adjust="46px">
            <input type="text"
                   :class="`form__field form__field--currency currency-wrapper__currency ${(def
                       ? `form__field--${def} js-${def} ${(showSpin ? 'currency-wrapper__currency--with-spin' : '')} ${(showLeftRight ? 'currency-wrapper__currency--with-buttons' : '')}`
                       : `${(showSpin ? 'currency-wrapper__currency--with-spin' : '')}` )} ${(showLeftRight ? 'currency-wrapper__currency--with-buttons' : '')}`"
                   :name="def" :id="def"
                   :placeholder="placeholder"
                   :value="valueDisplay"
                   :readonly="makeReadOnly"
                   :disabled="disabled"
                   @input="onInput">
        </hh-tooltip>
        <div v-if="showSpin"
             class="currency-wrapper__spin-buttons">
            <hh-btn :text="incrementText"
                    class="currency-wrapper__spin-buttons__button currency-wrapper__spin-buttons__button--increment"
                    @keydown="onIncrementButtonKeyDown"
                    @keyup="onIncrementButtonKeyUp"
                    @mousedown="onIncrementButtonDown"
                    @mouseup="onIncrementButtonUp"
                    @touchstart="onIncrementButtonDown"
                    @touchend="onIncrementButtonUp"
                    @touchcancel="onIncrementButtonUp" />
            <hh-btn :text="decrementText"
                    class="currency-wrapper__spin-buttons__button currency-wrapper__spin-buttons__button--decrement"
                    @keydown="onDecrementButtonKeyDown"
                    @keyup="onDecrementButtonKeyUp"
                    @mousedown="onDecrementButtonDown"
                    @mouseup="onDecrementButtonUp"
                    @touchstart="onDecrementButtonDown"
                    @touchend="onDecrementButtonUp"
                    @touchcancel="onDecrementButtonUp" />
        </div>
        <div v-if="showLeftRight"
             class="currency-wrapper__buttons currency-wrapper__buttons--right">
            <hh-btn :text="incrementIconClass ? '' : incrementText"
                    :icon-class="incrementIconClass"
                    class="currency-wrapper__buttons__button currency-wrapper__buttons__button--increment"
                    @keydown="onIncrementButtonKeyDown"
                    @keyup="onIncrementButtonKeyUp"
                    @mousedown="onIncrementButtonDown"
                    @mouseup="onIncrementButtonUp"
                    @touchstart="onIncrementButtonDown"
                    @touchend="onIncrementButtonUp"
                    @touchcancel="onIncrementButtonUp" />
            <hh-btn v-if="showLeftRightFaster"
                    :text="incrementFastIconClass ? '' : incrementFastText"
                    :icon-class="incrementFastIconClass"
                    class="currency-wrapper__buttons__button currency-wrapper__buttons__button--increment-faster"
                    @keydown="onFastIncrementButtonKeyDown"
                    @keyup="onFastIncrementButtonKeyUp"
                    @mousedown="onFastIncrementButtonDown"
                    @mouseup="onFastIncrementButtonUp"
                    @touchstart="onFastIncrementButtonDown"
                    @touchend="onFastIncrementButtonUp"
                    @touchcancel="onFastIncrementButtonUp" />
        </div>
    </span>
    <span v-else
          :name="def" :id="def" class="currency">
        {{ valueDisplay }}
    </span>
</template>

<script>

import MathTools from '@/helpers/math-tools'

import FormControlInput from './form-control-input'

export default {

    props: {
        placeholder: {
            type: String,
            default: '',
        },
        value: {
            type: [ Number, String ],
            default: 0,
        },
        makeReadOnly: {
            type: Boolean,
            default: false,
        },
        currency: {
            type: String,
            default: '£',
        },
        displayAsLabel: {
            type: Boolean,
            default: false,
        },
        increment: {
            type: Number,
            default: 0,
        },
        incrementSpeed: {
            type: Number,
            default: 200,
        },
        fasterIncrement: {
            type: Number,
            default: 0,
        },
        spinButtons: {
            type: Boolean,
            default: false,
        },
        leftRightButtons: {
            type: Boolean,
            default: false,
        },
        fasterLeftRightButtons: {
            type: Boolean,
            default: false,
        },
        incrementText: {
            type: String,
            default: '+',
        },
        decrementText: {
            type: String,
            default: '-',
        },
        incrementFastText: {
            type: String,
            default: '>>',
        },
        decrementFastText: {
            type: String,
            default: '<<',
        },
        incrementIconClass: {
            type: String,
            default: null,
        },
        decrementIconClass: {
            type: String,
            default: null,
        },
        incrementFastIconClass: {
            type: String,
            default: null,
        },
        decrementFastIconClass: {
            type: String,
            default: null,
        },
    },

    mixins: [
        FormControlInput,
    ],

    data() {
        return {
            incrementTimer: null,
            decrementTimer: null,
            fastIncrementTimer: null,
            fastDecrementTimer: null,
        }
    },

    computed: {

        fastIncrement() {
            return this.increment * 10
        },

        showSpin() {
            return !this.displayAsLabel && this.spinButtons
        },

        showLeftRight() {
            return !this.displayAsLabel && !this.spinButtons && this.leftRightButtons
        },

        showLeftRightFaster() {
            return this.showLeftRight && this.fasterLeftRightButtons
        },

        valueDisplay() {
            return MathTools.segmentCurrency(this.internalValue, this.currency)
        },
    },

    methods: {

        onDecrementButtonDown(ev) {
            this._repeatDecrement()
            ev.preventDefault()
        },

        onDecrementButtonUp(ev) {
            this._stopRepeatAndEmit(this.decrementTimer)
            ev.preventDefault()
        },

        onDecrementButtonKeyDown(ev) {
            if (ev.keyCode === 13) this._repeatDecrement()
        },

        onDecrementButtonKeyUp(ev) {
            if (ev.keyCode === 13) this._stopRepeatAndEmit(this.decrementTimer)
        },

        onFastDecrementButtonDown(ev) {
            this._repeatFastDecrement()
            ev.preventDefault()
        },

        onFastDecrementButtonUp(ev) {
            this._stopRepeatAndEmit(this.fastDecrementTimer)
            ev.preventDefault()
        },

        onFastDecrementButtonKeyDown(ev) {
            if (ev.keyCode === 13) this._repeatFastDecrement()
        },

        onFastDecrementButtonKeyUp(ev) {
            if (ev.keyCode === 13) this._stopRepeatAndEmit(this.fastDecrementTimer)
        },

        onFastIncrementButtonDown(ev) {
            this._repeatFastIncrement()
            ev.preventDefault()
        },

        onFastIncrementButtonUp(ev) {
            this._stopRepeatAndEmit(this.fastIncrementTimer)
            ev.preventDefault()
        },

        onFastIncrementButtonKeyDown(ev) {
            if (ev.keyCode === 13) this._repeatFastIncrement()
        },

        onFastIncrementButtonKeyUp(ev) {
            if (ev.keyCode === 13) this._stopRepeatAndEmit(this.fastIncrementTimer)
        },

        onIncrementButtonDown(ev) {
            this._repeatIncrement()
            ev.preventDefault()
        },

        onIncrementButtonUp(ev) {
            this._stopRepeatAndEmit(this.incrementTimer)
            ev.preventDefault()
        },

        onIncrementButtonKeyDown(ev) {
            if (ev.keyCode === 13) this._repeatIncrement()
        },

        onIncrementButtonKeyUp(ev) {
            if (ev.keyCode === 13) this._stopRepeatAndEmit(this.incrementTimer)
        },

        /**
         * Formats the output of event values. This can be overridden to format for specific control types.
         *
         * @param {any} value
         * @returns {any} The formatted output according to the control.
         */
        formatEventOutput(value) {
            return parseInt(this._cleanValue(value))
        },

        _cleanValue(value) {
            return String(value).replace(/[^\d.-]/g, '')
        },

        _clearAllActiveTimers() {
            if (this.decrementTimer) clearTimeout(this.decrementTimer)
            if (this.incrementTimer) clearTimeout(this.incrementTimer)
            if (this.fastDecrementTimer) clearTimeout(this.fastDecrementTimer)
            if (this.fastIncrementTimer) clearTimeout(this.fastIncrementTimer)
        },

        _stopRepeatAndEmit(timer) {
            clearTimeout(timer)
            this.$emit('input', this.internalValue)
        },

        _repeatDecrement() {
            this._clearAllActiveTimers()
            if (this.internalValue > this.increment) {
                this.internalValue = parseInt(this._cleanValue(this.internalValue - this.increment))
                this.decrementTimer = setTimeout(this._repeatDecrement, this.incrementSpeed)
            }
        },

        _repeatFastDecrement() {
            this._clearAllActiveTimers()
            if (this.internalValue > this.fastIncrement) {
                this.internalValue = parseInt(this._cleanValue(this.internalValue - this.fastIncrement))
                this.fastDecrementTimer = setTimeout(this._repeatFastDecrement, this.incrementSpeed)
            }
        },

        _repeatFastIncrement() {
            this._clearAllActiveTimers()
            this.internalValue = parseInt(this._cleanValue(this.internalValue + this.fastIncrement))
            this.fastIncrementTimer = setTimeout(this._repeatFastIncrement, this.incrementSpeed)
        },

        _repeatIncrement() {
            this._clearAllActiveTimers()
            this.internalValue = parseInt(this._cleanValue(this.internalValue + this.increment))
            this.incrementTimer = setTimeout(this._repeatIncrement, this.incrementSpeed)
        },
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.

@mixin currency-buttons {
    display: inline-block;
    @include user-select-none;
    height: 100%;
}

.currency-wrapper {
    position: relative;
    display: block;
    white-space: nowrap;

    @include element('currency') {

        @include modifier('with-spin') {
            display: inline-block;
            width: 85% !important;
        }

        @include modifier('with-buttons') {
            display: inline-block;
            margin: 0 1px;
            flex: 1 6 auto;
        }
    }

    @include element('buttons') {
        @include currency-buttons;
        flex: 0 0 auto;

        @include element('button') {
            margin: 0 1px;
            font-weight: bold;
            width: 2.5em;
            height: 100%;
        }
    }

    @include element('spin-buttons') {
        @include currency-buttons;
        position: absolute;
        top: 0;
        right: 0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 11%;

        @include element('button') {
            margin: 0;
            padding: 0;
            width: 1.5em;
            font-size: 0.8em;
            border-radius: 2px !important;
            border: none !important;
        }
    }

    @include modifier('with-buttons') {
        display: flex;
        align-items: center;
    }
}

.form {

    @include element('field') {

        @include modifier('currency') {
            @include read-only-field;
        }
    }
}

</style>
